import { SET_INITIAL_PROPS } from 'data_system/token_auth/actionTypes';

const defaultState = {
  brand: {},
};

export const initialPropsReducer = (state = defaultState, action) => {
  const { type, props } = action;

  switch (type) {
    case SET_INITIAL_PROPS:
      return props;
    default:
      return state;
  }
};
